<template>
  <div
    class="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50 py-8"
  >
    <div class="max-w-4xl mx-auto px-4">
      <!-- Header -->
      <div class="mb-8 animate-fade-in">
        <router-link
          to="/"
          class="inline-flex items-center space-x-2 text-gray-600 hover:text-primary-600 transition-all duration-300 group mb-4"
        >
          <svg
            class="w-5 h-5 transform group-hover:-translate-x-1 transition-transform"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 19l-7-7 7-7"
            ></path>
          </svg>
          <span class="font-medium">Voltar</span>
        </router-link>

        <div class="flex items-center space-x-3">
          <div
            class="p-3 bg-gradient-to-br from-primary-500 to-primary-600 rounded-xl shadow-lg"
          >
            <svg
              class="w-7 h-7 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
              ></path>
            </svg>
          </div>
          <div>
            <h1 class="text-3xl font-bold text-gray-900">Criar Post</h1>
            <p class="text-gray-600 mt-1">
              Crie conteúdo com IA ou escreva manualmente
            </p>
          </div>
        </div>
      </div>

      <!-- Mode Tabs -->
      <div class="mode-tabs mb-6 animate-slide-up">
        <button
          @click="mode = 'ai'"
          :class="['mode-tab', mode === 'ai' ? 'mode-tab-active' : '']"
        >
          <svg
            class="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 10V3L4 14h7v7l9-11h-7z"
            ></path>
          </svg>
          <span>Gerar com IA</span>
        </button>
        <button
          @click="mode = 'manual'"
          :class="['mode-tab', mode === 'manual' ? 'mode-tab-active' : '']"
        >
          <svg
            class="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
            ></path>
          </svg>
          <span>Escrever Manualmente</span>
        </button>
      </div>

      <!-- ==================== AI MODE ==================== -->
      <div v-if="mode === 'ai'" class="card-modern animate-slide-up">
        <form @submit.prevent="handleSubmit">
          <div class="space-y-8">
            <!-- Theme Input Section -->
            <div class="input-section">
              <label for="theme" class="label-modern">
                <span class="flex items-center space-x-2">
                  <svg
                    class="w-5 h-5 text-primary-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
                    ></path>
                  </svg>
                  <span>Tema do Post</span>
                </span>
              </label>
              <div class="relative group">
                <input
                  id="theme"
                  v-model="theme"
                  type="text"
                  required
                  placeholder="Ex: Inteligência Artificial, Desenvolvimento Web..."
                  class="input-modern"
                  :disabled="loading"
                />
                <div class="input-glow"></div>
              </div>
              <p class="text-sm text-gray-500 mt-2 flex items-start space-x-2">
                <svg
                  class="w-4 h-4 text-primary-500 mt-0.5 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  ></path>
                </svg>
                <span
                  >A IA irá gerar automaticamente o título, conteúdo e uma
                  imagem relacionada ao tema</span
                >
              </p>
            </div>

            <!-- Generation Progress -->
            <div v-if="loading" class="progress-section">
              <div class="flex items-center justify-between mb-4">
                <h3
                  class="font-semibold text-gray-900 flex items-center space-x-2"
                >
                  <div class="spinner-modern"></div>
                  <span>Gerando Post com IA</span>
                </h3>
                <span class="text-sm text-gray-500">Aguarde...</span>
              </div>

              <div class="space-y-3">
                <div
                  class="progress-item"
                  :class="{
                    active: currentStep >= 1,
                    completed: currentStep > 1,
                  }"
                >
                  <div class="progress-icon">
                    <svg
                      v-if="currentStep > 1"
                      class="w-4 h-4 text-white"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    <div v-else class="spinner-small"></div>
                  </div>
                  <div class="progress-content">
                    <span class="progress-title"
                      >Gerando título e conteúdo</span
                    >
                    <div
                      class="progress-bar"
                      :class="{ animate: currentStep === 1 }"
                    ></div>
                  </div>
                </div>

                <div
                  class="progress-item"
                  :class="{
                    active: currentStep >= 2,
                    completed: currentStep > 2,
                  }"
                >
                  <div class="progress-icon">
                    <svg
                      v-if="currentStep > 2"
                      class="w-4 h-4 text-white"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    <div v-else class="spinner-small"></div>
                  </div>
                  <div class="progress-content">
                    <span class="progress-title"
                      >Criando prompt para imagem</span
                    >
                    <div
                      class="progress-bar"
                      :class="{ animate: currentStep === 2 }"
                    ></div>
                  </div>
                </div>

                <div
                  class="progress-item"
                  :class="{
                    active: currentStep >= 3,
                    completed: currentStep > 3,
                  }"
                >
                  <div class="progress-icon">
                    <svg
                      v-if="currentStep > 3"
                      class="w-4 h-4 text-white"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    <div v-else class="spinner-small"></div>
                  </div>
                  <div class="progress-content">
                    <span class="progress-title"
                      >Buscando imagem relacionada</span
                    >
                    <div
                      class="progress-bar"
                      :class="{ animate: currentStep === 3 }"
                    ></div>
                  </div>
                </div>

                <div
                  class="progress-item"
                  :class="{
                    active: currentStep >= 4,
                    completed: currentStep > 4,
                  }"
                >
                  <div class="progress-icon">
                    <svg
                      v-if="currentStep > 4"
                      class="w-4 h-4 text-white"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    <div v-else class="spinner-small"></div>
                  </div>
                  <div class="progress-content">
                    <span class="progress-title"
                      >Salvando no banco de dados</span
                    >
                    <div
                      class="progress-bar"
                      :class="{ animate: currentStep === 4 }"
                    ></div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Preview Section - Idêntico ao PostDetail -->
            <div v-if="generatedContent" class="preview-section-fullscreen">
              <!-- Preview Header with Badge -->
              <div class="preview-badge-container">
                <div class="preview-badge">
                  <svg
                    class="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    ></path>
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                    ></path>
                  </svg>
                  <span>Modo Prévia</span>
                </div>
              </div>

              <!-- Post Preview - Same as PostDetail.vue -->
              <article class="post-preview-article">
                <!-- Hero Image Section -->
                <div v-if="generatedContent.imageUrl" class="post-hero-image">
                  <div class="post-hero-gradient"></div>
                  <img
                    :src="generatedContent.imageUrl"
                    :alt="generatedContent.title"
                    class="post-hero-img"
                  />

                  <!-- Floating Header on Image -->
                  <div class="post-hero-header">
                    <div class="post-hero-content">
                      <h1 class="post-hero-title">
                        {{ generatedContent.title }}
                      </h1>
                    </div>
                  </div>
                </div>

                <!-- Content Container -->
                <div class="post-content-wrapper">
                  <!-- Header (quando não há imagem) -->
                  <header
                    v-if="!generatedContent.imageUrl"
                    class="post-header-no-image"
                  >
                    <span class="post-theme-badge">
                      <span class="post-theme-dot"></span>
                      {{ generatedContent.theme }}
                    </span>

                    <h1 class="post-title-no-image">
                      {{ generatedContent.title }}
                    </h1>
                  </header>

                  <!-- Author & Meta Info -->
                  <div class="post-meta-section">
                    <div class="post-author-info">
                      <div class="post-author-avatar">
                        <span class="post-author-initial">
                          {{
                            authStore.user?.username?.charAt(0).toUpperCase() ||
                            "A"
                          }}
                        </span>
                      </div>
                      <div>
                        <p class="post-author-name">
                          {{ authStore.user?.username || "Admin" }}
                        </p>
                        <div class="post-meta-details">
                          <span>Agora</span>
                          <span class="post-meta-separator">•</span>
                          <span
                            >{{
                              calculateReadingTime(generatedContent.content)
                            }}
                            min de leitura</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Post Content - Magazine Style -->
                  <div class="post-content-container">
                    <div
                      v-html="formatContent(generatedContent.content)"
                      class="post-content-modern"
                      ref="previewContentRef"
                    ></div>
                  </div>
                </div>
              </article>

              <!-- Floating Action Bar -->
              <div class="preview-action-bar">
                <div class="preview-actions-content">
                  <button
                    type="button"
                    @click="regeneratePost"
                    :disabled="loading"
                    class="btn-preview-secondary"
                  >
                    <svg
                      class="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                      ></path>
                    </svg>
                    <span v-if="loading">Gerando...</span>
                    <span v-else>Gerar Novamente</span>
                  </button>

                  <button
                    type="button"
                    @click="publishPost"
                    :disabled="loading"
                    class="btn-preview-primary"
                  >
                    <svg
                      class="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                      ></path>
                    </svg>
                    <span v-if="loading">Publicando...</span>
                    <span v-else>Publicar Post</span>
                  </button>
                </div>
              </div>
            </div>

            <!-- Submit Button -->
            <div
              v-if="!generatedContent"
              class="flex justify-end space-x-4 pt-6 border-t border-gray-100"
            >
              <router-link to="/" class="btn-cancel-modern">
                Cancelar
              </router-link>
              <button
                type="submit"
                :disabled="!theme.trim() || loading"
                class="btn-generate-modern"
              >
                <svg
                  class="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13 10V3L4 14h7v7l9-11h-7z"
                  ></path>
                </svg>
                <span v-if="loading">Gerando...</span>
                <span v-else>Gerar com IA</span>
              </button>
            </div>
          </div>
        </form>
      </div>

      <!-- ==================== MANUAL MODE ==================== -->
      <div v-if="mode === 'manual'" class="animate-slide-up">
        <div class="card-modern">
          <div class="space-y-6">
            <!-- Title -->
            <div class="input-section">
              <label for="manualTitle" class="label-modern">
                <span class="flex items-center space-x-2">
                  <svg
                    class="w-5 h-5 text-primary-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
                    ></path>
                  </svg>
                  <span>Título do Post</span>
                </span>
              </label>
              <input
                id="manualTitle"
                v-model="manualTitle"
                type="text"
                required
                placeholder="Escreva o título do seu post..."
                class="input-modern"
                :disabled="manualLoading"
                maxlength="255"
              />
              <p class="text-xs text-gray-400 mt-1 text-right">
                {{ manualTitle.length }}/255
              </p>
            </div>

            <!-- Theme -->
            <div class="input-section">
              <label for="manualTheme" class="label-modern">
                <span class="flex items-center space-x-2">
                  <svg
                    class="w-5 h-5 text-primary-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
                    ></path>
                  </svg>
                  <span
                    >Tema / Categoria
                    <span class="text-gray-400 font-normal"
                      >(opcional)</span
                    ></span
                  >
                </span>
              </label>
              <input
                id="manualTheme"
                v-model="manualTheme"
                type="text"
                placeholder="Ex: Tecnologia, Programação, IA..."
                class="input-modern"
                :disabled="manualLoading"
              />
            </div>

            <!-- Image Section -->
            <div class="input-section">
              <label class="label-modern">
                <span class="flex items-center space-x-2">
                  <svg
                    class="w-5 h-5 text-primary-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                    ></path>
                  </svg>
                  <span
                    >Imagem de Capa
                    <span class="text-gray-400 font-normal"
                      >(opcional)</span
                    ></span
                  >
                </span>
              </label>

              <!-- Image Mode Tabs -->
              <div class="image-mode-tabs">
                <button
                  type="button"
                  @click="imageMode = 'url'"
                  :class="[
                    'image-mode-tab',
                    imageMode === 'url' ? 'image-mode-tab-active' : '',
                  ]"
                >
                  <svg
                    class="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                    ></path>
                  </svg>
                  URL
                </button>
                <button
                  type="button"
                  @click="imageMode = 'upload'"
                  :class="[
                    'image-mode-tab',
                    imageMode === 'upload' ? 'image-mode-tab-active' : '',
                  ]"
                >
                  <svg
                    class="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
                    ></path>
                  </svg>
                  Upload
                </button>
              </div>

              <!-- URL Mode -->
              <div v-if="imageMode === 'url'" class="mt-3">
                <input
                  v-model="manualImageUrl"
                  type="url"
                  placeholder="https://images.unsplash.com/..."
                  class="input-modern"
                  :disabled="manualLoading"
                />
              </div>

              <!-- Upload Mode -->
              <div v-if="imageMode === 'upload'" class="mt-3">
                <div
                  class="upload-dropzone"
                  :class="{ 'upload-dropzone-active': isDragging }"
                  @dragover.prevent="isDragging = true"
                  @dragleave.prevent="isDragging = false"
                  @drop.prevent="handleImageDrop"
                  @click="fileInput && fileInput.click()"
                >
                  <input
                    ref="fileInput"
                    type="file"
                    accept="image/jpeg,image/png,image/webp,image/gif"
                    class="hidden"
                    @change="handleFileSelect"
                  />
                  <div
                    v-if="!uploadedImagePreview && !imageUploading"
                    class="upload-placeholder"
                  >
                    <svg
                      class="w-10 h-10 text-gray-400 mx-auto mb-3"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                        d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                      ></path>
                    </svg>
                    <p class="text-sm text-gray-600 font-medium">
                      Clique ou arraste uma imagem aqui
                    </p>
                    <p class="text-xs text-gray-400 mt-1">
                      JPG, PNG, WebP ou GIF — Máximo 5MB
                    </p>
                  </div>
                  <div v-if="imageUploading" class="upload-placeholder">
                    <div class="spinner-modern mx-auto mb-3"></div>
                    <p class="text-sm text-gray-600 font-medium">
                      Processando imagem...
                    </p>
                  </div>
                </div>
              </div>

              <!-- Image Preview (both modes) -->
              <div v-if="imagePreviewSrc" class="mt-3 relative">
                <div class="image-preview">
                  <img
                    :src="imagePreviewSrc"
                    alt="Preview da imagem"
                    class="preview-image"
                    @error="imageError = true"
                    @load="imageError = false"
                  />
                  <button
                    type="button"
                    @click="clearImage"
                    class="image-remove-btn"
                    title="Remover imagem"
                  >
                    <svg
                      class="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M6 18L18 6M6 6l12 12"
                      ></path>
                    </svg>
                  </button>
                </div>
                <p v-if="uploadedImageSize" class="text-xs text-gray-400 mt-1">
                  {{ uploadedImageSize }}
                </p>
              </div>
            </div>

            <!-- Markdown Editor -->
            <div class="input-section">
              <label class="label-modern">
                <span class="flex items-center space-x-2">
                  <svg
                    class="w-5 h-5 text-primary-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                    ></path>
                  </svg>
                  <span
                    >Conteúdo
                    <span class="text-gray-400 font-normal"
                      >(Markdown)</span
                    ></span
                  >
                </span>
              </label>

              <!-- Toolbar -->
              <div class="editor-toolbar">
                <button
                  type="button"
                  @click="insertMarkdown('bold')"
                  title="Negrito (Ctrl+B)"
                  class="toolbar-btn"
                >
                  <strong>B</strong>
                </button>
                <button
                  type="button"
                  @click="insertMarkdown('italic')"
                  title="Itálico (Ctrl+I)"
                  class="toolbar-btn"
                >
                  <em>I</em>
                </button>
                <button
                  type="button"
                  @click="insertMarkdown('h2')"
                  title="Título H2"
                  class="toolbar-btn"
                >
                  H2
                </button>
                <button
                  type="button"
                  @click="insertMarkdown('h3')"
                  title="Título H3"
                  class="toolbar-btn"
                >
                  H3
                </button>
                <div class="toolbar-separator"></div>
                <button
                  type="button"
                  @click="insertMarkdown('link')"
                  title="Link"
                  class="toolbar-btn"
                >
                  <svg
                    class="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                    ></path>
                  </svg>
                </button>
                <button
                  type="button"
                  @click="insertMarkdown('image')"
                  title="Imagem"
                  class="toolbar-btn"
                >
                  <svg
                    class="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                    ></path>
                  </svg>
                </button>
                <div class="toolbar-separator"></div>
                <button
                  type="button"
                  @click="insertMarkdown('ul')"
                  title="Lista"
                  class="toolbar-btn"
                >
                  <svg
                    class="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M4 6h16M4 10h16M4 14h16M4 18h16"
                    ></path>
                  </svg>
                </button>
                <button
                  type="button"
                  @click="insertMarkdown('ol')"
                  title="Lista Numerada"
                  class="toolbar-btn"
                >
                  <span class="text-xs font-bold">1.</span>
                </button>
                <button
                  type="button"
                  @click="insertMarkdown('blockquote')"
                  title="Citação"
                  class="toolbar-btn"
                >
                  <svg
                    class="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
                    ></path>
                  </svg>
                </button>
                <button
                  type="button"
                  @click="insertMarkdown('code')"
                  title="Código"
                  class="toolbar-btn"
                >
                  <svg
                    class="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
                    ></path>
                  </svg>
                </button>
                <button
                  type="button"
                  @click="insertMarkdown('hr')"
                  title="Linha Horizontal"
                  class="toolbar-btn"
                >
                  <span class="text-xs font-bold">―</span>
                </button>
                <div class="toolbar-separator"></div>
                <button
                  type="button"
                  @click="showPreview = !showPreview"
                  :class="[
                    'toolbar-btn',
                    showPreview ? 'toolbar-btn-active' : '',
                  ]"
                  title="Preview"
                >
                  <svg
                    class="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    ></path>
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                    ></path>
                  </svg>
                </button>
              </div>

              <!-- Editor + Preview -->
              <div
                :class="['editor-container', showPreview ? 'editor-split' : '']"
              >
                <div class="editor-pane">
                  <textarea
                    ref="editorRef"
                    v-model="manualContent"
                    placeholder="Escreva seu conteúdo em Markdown...&#10;&#10;## Subtítulo&#10;&#10;Parágrafo com **negrito** e *itálico*.&#10;&#10;- Item da lista&#10;- Outro item&#10;&#10;```javascript&#10;console.log('Hello World');&#10;```"
                    class="editor-textarea"
                    :disabled="manualLoading"
                    @keydown="handleEditorKeydown"
                  ></textarea>
                </div>
                <div v-if="showPreview" class="preview-pane">
                  <div class="preview-pane-header">
                    <svg
                      class="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      ></path>
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                      ></path>
                    </svg>
                    <span>Preview</span>
                  </div>
                  <div
                    v-html="manualPreviewHtml"
                    class="post-content-modern preview-pane-content"
                    ref="manualPreviewRef"
                  ></div>
                </div>
              </div>
              <p class="text-xs text-gray-400 mt-1">
                {{ manualContent.length }} caracteres
              </p>
            </div>

            <!-- Action Buttons -->
            <div
              class="flex justify-end space-x-4 pt-6 border-t border-gray-100"
            >
              <router-link to="/" class="btn-cancel-modern">
                Cancelar
              </router-link>
              <button
                type="button"
                @click="saveManualDraft"
                :disabled="!canSaveManual || manualLoading"
                class="btn-generate-modern"
              >
                <svg
                  class="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"
                  ></path>
                </svg>
                <span v-if="manualLoading">Salvando...</span>
                <span v-else>Salvar Rascunho</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Manual Post Full Preview -->
        <div v-if="manualSavedPost" class="mt-6">
          <div class="preview-section-fullscreen">
            <div class="preview-badge-container">
              <div class="preview-badge">
                <svg
                  class="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  ></path>
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                  ></path>
                </svg>
                <span>Rascunho Salvo</span>
              </div>
            </div>

            <article class="post-preview-article">
              <div v-if="manualSavedPost.image_url" class="post-hero-image">
                <div class="post-hero-gradient"></div>
                <img
                  :src="manualSavedPost.image_url"
                  :alt="manualSavedPost.title"
                  class="post-hero-img"
                />
                <div class="post-hero-header">
                  <div class="post-hero-content">
                    <h1 class="post-hero-title">{{ manualSavedPost.title }}</h1>
                  </div>
                </div>
              </div>

              <div class="post-content-wrapper">
                <header
                  v-if="!manualSavedPost.image_url"
                  class="post-header-no-image"
                >
                  <span v-if="manualSavedPost.theme" class="post-theme-badge">
                    <span class="post-theme-dot"></span>
                    {{ manualSavedPost.theme }}
                  </span>
                  <h1 class="post-title-no-image">
                    {{ manualSavedPost.title }}
                  </h1>
                </header>

                <div class="post-meta-section">
                  <div class="post-author-info">
                    <div class="post-author-avatar">
                      <span class="post-author-initial">
                        {{
                          authStore.user?.username?.charAt(0).toUpperCase() ||
                          "A"
                        }}
                      </span>
                    </div>
                    <div>
                      <p class="post-author-name">
                        {{ authStore.user?.username || "Admin" }}
                      </p>
                      <div class="post-meta-details">
                        <span>Agora</span>
                        <span class="post-meta-separator">&bull;</span>
                        <span
                          >{{
                            calculateReadingTime(manualSavedPost.content)
                          }}
                          min de leitura</span
                        >
                      </div>
                    </div>
                  </div>
                </div>

                <div class="post-content-container">
                  <div
                    v-html="formatContent(manualSavedPost.content)"
                    class="post-content-modern"
                    ref="manualSavedPreviewRef"
                  ></div>
                </div>
              </div>
            </article>

            <div class="preview-action-bar">
              <div class="preview-actions-content">
                <button
                  type="button"
                  @click="manualSavedPost = null"
                  class="btn-preview-secondary"
                >
                  <svg
                    class="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                    ></path>
                  </svg>
                  <span>Continuar Editando</span>
                </button>
                <button
                  type="button"
                  @click="publishManualPost"
                  :disabled="manualLoading"
                  class="btn-preview-primary"
                >
                  <svg
                    class="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                    ></path>
                  </svg>
                  <span v-if="manualLoading">Publicando...</span>
                  <span v-else>Publicar Post</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Success Message -->
      <transition name="success-fade">
        <div v-if="successMessage" class="success-message">
          <div class="success-icon">
            <svg
              class="w-6 h-6 text-white"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
          <div class="success-content">
            <h4 class="success-title">Sucesso!</h4>
            <p class="success-text">{{ successMessage }}</p>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { ref, computed, watch, nextTick } from "vue";
import { useRouter } from "vue-router";
import apiService from "@/services/api";
import { useToast } from "vue-toastification";
import { markdownToHtml } from "@/utils/contentUtils";
import { useAuthStore } from "@/store/auth";
import Prism from "prismjs";

export default {
  name: "AdminCreatePost",
  setup() {
    const router = useRouter();
    const toast = useToast();
    const authStore = useAuthStore();

    // Shared state
    const mode = ref("ai");
    const successMessage = ref("");

    // AI mode state
    const theme = ref("");
    const loading = ref(false);
    const currentStep = ref(0);
    const generatedContent = ref(null);
    const isPublished = ref(false);
    const previewContentRef = ref(null);

    // Manual mode state
    const manualTitle = ref("");
    const manualTheme = ref("");
    const manualImageUrl = ref("");
    const manualContent = ref("");
    const manualLoading = ref(false);
    const manualSavedPost = ref(null);
    const showPreview = ref(false);
    const imageError = ref(false);
    const editorRef = ref(null);
    const fileInput = ref(null);
    const manualPreviewRef = ref(null);
    const manualSavedPreviewRef = ref(null);

    // Image upload state
    const imageMode = ref("url");
    const uploadedImageBase64 = ref("");
    const uploadedImagePreview = ref("");
    const uploadedImageSize = ref("");
    const imageUploading = ref(false);
    const isDragging = ref(false);

    const canSaveManual = computed(() => {
      return (
        manualTitle.value.trim().length > 0 &&
        manualContent.value.trim().length >= 50
      );
    });

    const imagePreviewSrc = computed(() => {
      if (imageMode.value === "upload" && uploadedImagePreview.value) {
        return uploadedImagePreview.value;
      }
      if (
        imageMode.value === "url" &&
        manualImageUrl.value &&
        isValidUrl(manualImageUrl.value)
      ) {
        return manualImageUrl.value;
      }
      return null;
    });

    const finalImageValue = computed(() => {
      if (imageMode.value === "upload" && uploadedImageBase64.value) {
        return uploadedImageBase64.value;
      }
      if (imageMode.value === "url" && manualImageUrl.value.trim()) {
        return manualImageUrl.value.trim();
      }
      return undefined;
    });

    const manualPreviewHtml = computed(() => {
      if (!manualContent.value)
        return '<p class="text-gray-400 italic">O preview aparecerá aqui...</p>';
      return markdownToHtml(manualContent.value);
    });

    const isValidUrl = (url) => {
      try {
        new URL(url);
        return true;
      } catch {
        return false;
      }
    };

    // Image compression utility
    const compressImage = (file, maxWidth = 1200, quality = 0.8) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement("canvas");
            let width = img.width;
            let height = img.height;

            if (width > maxWidth) {
              height = Math.round((height * maxWidth) / width);
              width = maxWidth;
            }

            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);

            const base64 = canvas.toDataURL("image/jpeg", quality);
            resolve(base64);
          };
          img.onerror = () => reject(new Error("Falha ao carregar imagem"));
          img.src = e.target.result;
        };
        reader.onerror = () => reject(new Error("Falha ao ler arquivo"));
        reader.readAsDataURL(file);
      });
    };

    const formatFileSize = (bytes) => {
      if (bytes < 1024) return bytes + " B";
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
      return (bytes / (1024 * 1024)).toFixed(1) + " MB";
    };

    const processImageFile = async (file) => {
      if (!file) return;

      // Validate type
      const validTypes = ["image/jpeg", "image/png", "image/webp", "image/gif"];
      if (!validTypes.includes(file.type)) {
        toast.error("Formato não suportado. Use JPG, PNG, WebP ou GIF.");
        return;
      }

      // Validate size (5MB)
      if (file.size > 5 * 1024 * 1024) {
        toast.error("Imagem muito grande. O tamanho máximo é 5MB.");
        return;
      }

      imageUploading.value = true;
      try {
        let base64 = await compressImage(file);

        // Se a imagem comprimida ainda for grande (>3MB), recomprimir com qualidade menor
        let base64Data = base64.split(",")[1] || "";
        let compressedBytes = Math.round((base64Data.length * 3) / 4);
        if (compressedBytes > 3 * 1024 * 1024) {
          base64 = await compressImage(file, 1000, 0.6);
          base64Data = base64.split(",")[1] || "";
          compressedBytes = Math.round((base64Data.length * 3) / 4);
        }

        if (compressedBytes > 4 * 1024 * 1024) {
          toast.error(
            "Imagem muito grande mesmo após compressão. Tente uma imagem menor."
          );
          return;
        }

        uploadedImageBase64.value = base64;
        uploadedImagePreview.value = base64;

        uploadedImageSize.value = `Original: ${formatFileSize(
          file.size
        )} → Comprimida: ${formatFileSize(compressedBytes)}`;

        toast.success("Imagem carregada com sucesso!");
      } catch (error) {
        console.error("Erro ao processar imagem:", error);
        toast.error("Erro ao processar imagem. Tente outra.");
      } finally {
        imageUploading.value = false;
      }
    };

    const handleFileSelect = (event) => {
      const file = event.target.files[0];
      processImageFile(file);
      // Reset input so same file can be re-selected
      event.target.value = "";
    };

    const handleImageDrop = (event) => {
      isDragging.value = false;
      const file = event.dataTransfer.files[0];
      processImageFile(file);
    };

    const clearImage = () => {
      if (imageMode.value === "upload") {
        uploadedImageBase64.value = "";
        uploadedImagePreview.value = "";
        uploadedImageSize.value = "";
      } else {
        manualImageUrl.value = "";
      }
      imageError.value = false;
    };

    const formatContent = (content) => {
      if (!content) return "<p>Conteúdo não disponível.</p>";
      return markdownToHtml(content);
    };

    const calculateReadingTime = (content) => {
      if (!content) return 0;
      const wordsPerMinute = 200;
      const words = content.split(/\s+/).length;
      return Math.max(1, Math.ceil(words / wordsPerMinute));
    };

    // Highlight code blocks in previews
    const highlightCode = (el) => {
      if (el) {
        Prism.highlightAllUnder(el);
      }
    };

    watch(
      () => generatedContent.value,
      async (newContent) => {
        if (newContent) {
          await nextTick();
          setTimeout(() => highlightCode(previewContentRef.value), 100);
        }
      }
    );

    watch(manualPreviewHtml, async () => {
      if (showPreview.value) {
        await nextTick();
        setTimeout(() => highlightCode(manualPreviewRef.value), 100);
      }
    });

    watch(
      () => manualSavedPost.value,
      async (post) => {
        if (post) {
          await nextTick();
          setTimeout(() => highlightCode(manualSavedPreviewRef.value), 100);
        }
      }
    );

    // Markdown toolbar insert
    const insertMarkdown = (type) => {
      const textarea = editorRef.value;
      if (!textarea) return;

      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const selected = manualContent.value.substring(start, end);
      let insertion = "";
      let cursorOffset = 0;

      switch (type) {
        case "bold":
          insertion = `**${selected || "texto"}**`;
          cursorOffset = selected ? insertion.length : 2;
          break;
        case "italic":
          insertion = `*${selected || "texto"}*`;
          cursorOffset = selected ? insertion.length : 1;
          break;
        case "h2":
          insertion = `\n## ${selected || "Subtítulo"}\n`;
          cursorOffset = selected ? insertion.length : 4;
          break;
        case "h3":
          insertion = `\n### ${selected || "Subtítulo"}\n`;
          cursorOffset = selected ? insertion.length : 5;
          break;
        case "link":
          insertion = `[${selected || "texto"}](url)`;
          cursorOffset = selected ? insertion.length - 1 : 1;
          break;
        case "image":
          insertion = `![${selected || "descrição"}](url)`;
          cursorOffset = selected ? insertion.length - 1 : 2;
          break;
        case "ul":
          insertion = `\n- ${selected || "Item da lista"}\n`;
          cursorOffset = selected ? insertion.length : 3;
          break;
        case "ol":
          insertion = `\n1. ${selected || "Item da lista"}\n`;
          cursorOffset = selected ? insertion.length : 4;
          break;
        case "blockquote":
          insertion = `\n> ${selected || "Citação"}\n`;
          cursorOffset = selected ? insertion.length : 3;
          break;
        case "code":
          if (selected && selected.includes("\n")) {
            insertion = `\n\`\`\`\n${selected}\n\`\`\`\n`;
          } else {
            insertion = `\`${selected || "código"}\``;
          }
          cursorOffset = selected ? insertion.length : 1;
          break;
        case "hr":
          insertion = "\n\n---\n\n";
          cursorOffset = insertion.length;
          break;
      }

      manualContent.value =
        manualContent.value.substring(0, start) +
        insertion +
        manualContent.value.substring(end);

      nextTick(() => {
        textarea.focus();
        const pos = start + cursorOffset;
        textarea.setSelectionRange(pos, pos);
      });
    };

    // Keyboard shortcuts for editor
    const handleEditorKeydown = (e) => {
      if (e.ctrlKey || e.metaKey) {
        if (e.key === "b") {
          e.preventDefault();
          insertMarkdown("bold");
        } else if (e.key === "i") {
          e.preventDefault();
          insertMarkdown("italic");
        } else if (e.key === "k") {
          e.preventDefault();
          insertMarkdown("link");
        }
      }
      // Tab inserts spaces instead of moving focus
      if (e.key === "Tab") {
        e.preventDefault();
        const textarea = editorRef.value;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        manualContent.value =
          manualContent.value.substring(0, start) +
          "  " +
          manualContent.value.substring(end);
        nextTick(() => {
          textarea.setSelectionRange(start + 2, start + 2);
        });
      }
    };

    // Save manual draft
    const saveManualDraft = async () => {
      if (!canSaveManual.value) return;

      manualLoading.value = true;
      successMessage.value = "";

      try {
        const data = await apiService.post(
          "/api/handlers?module=admin&action=posts-manual",
          {
            title: manualTitle.value.trim(),
            content: manualContent.value.trim(),
            image_url: finalImageValue.value,
            theme: manualTheme.value.trim() || undefined,
          }
        );

        if (!data || !data.data || !data.data.post) {
          throw new Error("Resposta inválida do servidor");
        }

        manualSavedPost.value = data.data.post;
        successMessage.value =
          "Rascunho salvo com sucesso! Revise e publique quando estiver pronto.";
        toast.success("Rascunho salvo com sucesso!");
      } catch (error) {
        console.error("Erro ao salvar rascunho:", error);
        const message =
          error.response?.data?.message || "Erro ao salvar rascunho";
        toast.error(message);
      } finally {
        manualLoading.value = false;
      }
    };

    // Publish manual post
    const publishManualPost = async () => {
      if (!manualSavedPost.value) return;

      manualLoading.value = true;
      successMessage.value = "";

      try {
        const data = await apiService.post(
          "/api/handlers?module=admin&action=posts-publish",
          { postId: manualSavedPost.value.id }
        );

        if (data.emailResult && data.emailResult.sent > 0) {
          toast.success(
            `Post publicado! Emails enviados: ${data.emailResult.sent}/${data.emailResult.total}`
          );
        } else {
          toast.success("Post publicado com sucesso!");
        }

        successMessage.value = `Post "${manualSavedPost.value.title}" publicado com sucesso!`;

        setTimeout(() => {
          router.push("/admin");
        }, 3000);
      } catch (error) {
        console.error("Erro ao publicar post:", error);
        const message =
          error.response?.data?.message || "Erro ao publicar post";
        toast.error(message);
      } finally {
        manualLoading.value = false;
      }
    };

    // AI mode functions
    const generatePost = async () => {
      loading.value = true;
      currentStep.value = 0;
      successMessage.value = "";
      isPublished.value = false;

      try {
        currentStep.value = 1;
        await new Promise((resolve) => setTimeout(resolve, 500));
        currentStep.value = 2;
        await new Promise((resolve) => setTimeout(resolve, 500));
        currentStep.value = 3;
        await new Promise((resolve) => setTimeout(resolve, 500));
        currentStep.value = 4;

        const data = await apiService.post(
          "/api/handlers?module=admin&action=posts-preview",
          { theme: theme.value.trim() }
        );

        if (!data || !data.data) {
          throw new Error("Resposta inválida do servidor");
        }

        const { post, generated } = data.data;

        if (!post) {
          throw new Error("Post não foi gerado corretamente");
        }

        generatedContent.value = {
          title: post.title,
          content: post.content,
          theme: post.theme,
          imageUrl: post.image_url,
          imagePrompt: generated?.imagePrompt,
          postData: post,
        };

        successMessage.value = `Prévia gerada com sucesso! Revise o conteúdo e clique em "Publicar Post" quando estiver pronto.`;
        toast.success("Prévia gerada com sucesso!");
      } catch (error) {
        console.error("Erro ao gerar prévia:", error);

        let message = error.response?.data?.message || "Erro ao gerar prévia";
        let details = error.response?.data?.details || "";
        let toastType = "error";

        if (
          error.response?.status === 504 ||
          error.message?.includes("timeout")
        ) {
          message = "Tempo Limite Excedido (504)";
          details =
            "A geração do post demorou mais de 30 segundos.\n\nDicas:\n• Use um tema mais específico\n• Tente novamente";
          toastType = "warning";

          if (confirm("Tempo limite excedido!\n\nDeseja tentar novamente?")) {
            setTimeout(() => generatePost(), 1000);
            return;
          }
        } else if (
          error.response?.status === 503 ||
          message.includes("quota") ||
          message.includes("models de IA falharam")
        ) {
          message = "Quota da IA Esgotada (503)";
          details =
            details ||
            "Tente novamente em algumas horas após a renovação da quota.";
          toastType = "warning";
        }

        if (toastType === "warning") {
          toast.warning(message);
        } else {
          toast.error(message);
        }

        successMessage.value = details ? `${message}\n\n${details}` : message;
      } finally {
        loading.value = false;
        currentStep.value = 0;
      }
    };

    const handleSubmit = async () => {
      if (!theme.value.trim()) return;
      await generatePost();
    };

    const regeneratePost = async () => {
      await generatePost();
    };

    const publishPost = async () => {
      if (!generatedContent.value || isPublished.value) return;

      loading.value = true;
      successMessage.value = "";

      try {
        const data = await apiService.post(
          "/api/handlers?module=admin&action=posts-publish",
          { postId: generatedContent.value.postData.id }
        );

        if (data.emailResult) {
          if (data.emailResult.sent > 0) {
            toast.success(
              `Post publicado! Emails enviados: ${data.emailResult.sent}/${data.emailResult.total}`
            );
          } else if (data.emailResult.total > 0) {
            toast.warning("Post publicado, mas houve falha no envio de emails");
          }
        } else {
          toast.success("Post publicado com sucesso!");
        }

        isPublished.value = true;
        successMessage.value = `Post "${generatedContent.value.title}" publicado com sucesso!`;

        setTimeout(() => {
          router.push("/admin");
        }, 3000);
      } catch (error) {
        console.error("Erro ao publicar post:", error);
        const message =
          error.response?.data?.message || "Erro ao publicar post";
        toast.error(message);
      } finally {
        loading.value = false;
      }
    };

    return {
      authStore,
      mode,
      // AI mode
      theme,
      loading,
      currentStep,
      generatedContent,
      successMessage,
      previewContentRef,
      handleSubmit,
      regeneratePost,
      publishPost,
      formatContent,
      calculateReadingTime,
      // Manual mode
      manualTitle,
      manualTheme,
      manualImageUrl,
      manualContent,
      manualLoading,
      manualSavedPost,
      showPreview,
      imageError,
      editorRef,
      fileInput,
      manualPreviewRef,
      manualSavedPreviewRef,
      canSaveManual,
      manualPreviewHtml,
      isValidUrl,
      insertMarkdown,
      handleEditorKeydown,
      saveManualDraft,
      publishManualPost,
      // Image upload
      imageMode,
      uploadedImagePreview,
      uploadedImageSize,
      imageUploading,
      isDragging,
      imagePreviewSrc,
      handleFileSelect,
      handleImageDrop,
      clearImage,
    };
  },
};
</script>

<style scoped>
/* Animations */
@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slide-up {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes progress {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}

@keyframes pulse-glow {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.animate-fade-in {
  animation: fade-in 0.6s ease-out;
}

.animate-slide-up {
  animation: slide-up 0.6s ease-out;
}

/* Mode Tabs */
.mode-tabs {
  display: flex;
  gap: 0.5rem;
  background: white;
  padding: 0.5rem;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.mode-tab {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.875rem 1.5rem;
  font-size: 0.9375rem;
  font-weight: 600;
  color: #6b7280;
  background: transparent;
  border: 2px solid transparent;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.mode-tab:hover {
  background: #f9fafb;
  color: #374151;
}

.mode-tab-active {
  background: linear-gradient(135deg, #eff6ff 0%, #e0f2fe 100%);
  color: #1d4ed8;
  border-color: #93c5fd;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.15);
}

/* Card Styles */
.card-modern {
  background: white;
  border-radius: 24px;
  padding: 2.5rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05),
    0 2px 4px -1px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

/* Input Section */
.input-section {
  position: relative;
}

.label-modern {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.75rem;
}

.input-modern {
  width: 100%;
  padding: 1rem 1.25rem;
  font-size: 1rem;
  color: #1f2937;
  background: #f9fafb;
  border: 2px solid #e5e7eb;
  border-radius: 16px;
  transition: all 0.3s ease;
  outline: none;
}

.input-modern:focus {
  background: white;
  border-color: #6366f1;
  box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.1);
}

.input-modern:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.input-glow {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #6366f1, #8b5cf6, #ec4899);
  border-radius: 2px;
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.input-modern:focus ~ .input-glow {
  transform: scaleX(1);
}

/* Progress Section */
.progress-section {
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border: 2px solid #bae6fd;
  border-radius: 20px;
  padding: 2rem;
}

.spinner-modern {
  width: 20px;
  height: 20px;
  border: 3px solid #e0f2fe;
  border-top-color: #0284c7;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.progress-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 12px;
  border: 2px solid transparent;
  transition: all 0.3s ease;
}

.progress-item.active {
  background: white;
  border-color: #0284c7;
  box-shadow: 0 4px 12px rgba(2, 132, 199, 0.15);
}

.progress-item.completed {
  background: white;
  border-color: #10b981;
}

.progress-icon {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e5e7eb;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.progress-item.active .progress-icon {
  background: #0284c7;
}

.progress-item.completed .progress-icon {
  background: #10b981;
}

.spinner-small {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

.progress-content {
  flex: 1;
}

.progress-title {
  display: block;
  font-size: 0.9375rem;
  font-weight: 500;
  color: #1f2937;
  margin-bottom: 0.5rem;
}

.progress-bar {
  height: 4px;
  background: #e5e7eb;
  border-radius: 2px;
  overflow: hidden;
  position: relative;
}

.progress-bar.animate::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: linear-gradient(90deg, #0284c7, #06b6d4);
  animation: progress 2s ease-in-out infinite;
}

/* Preview Section */
.preview-section {
  background: linear-gradient(135deg, #fefce8 0%, #fef3c7 100%);
  border: 2px solid #fde047;
  border-radius: 20px;
  padding: 2rem;
}

.badge-success {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: #10b981;
  color: white;
  font-size: 0.875rem;
  font-weight: 600;
  border-radius: 999px;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.badge-success::before {
  content: "✓";
  font-size: 1rem;
}

.preview-label {
  display: block;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #78716c;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.75rem;
}

.preview-field {
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.preview-value {
  color: #1f2937;
}

.badge-theme {
  display: inline-flex;
  align-items: center;
  padding: 0.625rem 1.25rem;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: white;
  font-size: 0.9375rem;
  font-weight: 600;
  border-radius: 999px;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
}

.preview-content {
  background: white;
  padding: 1.5rem;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  max-height: 400px;
  overflow-y: auto;
  font-size: 0.9375rem;
  line-height: 1.7;
  color: #4b5563;
}

.preview-content::-webkit-scrollbar {
  width: 8px;
}

.preview-content::-webkit-scrollbar-track {
  background: #f3f4f6;
  border-radius: 4px;
}

.preview-content::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 4px;
}

.preview-content::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

/* Image Preview */
.image-preview-container {
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.image-preview {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  aspect-ratio: 16/9;
  background: #f3f4f6;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.image-preview:hover .preview-image {
  transform: scale(1.05);
}

.image-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.5), transparent);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 1.5rem;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-preview:hover .image-overlay {
  opacity: 1;
}

/* Preview Actions */
.preview-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  padding-top: 2rem;
  margin-top: 2rem;
  border-top: 2px solid rgba(0, 0, 0, 0.05);
}

/* Buttons */
.btn-secondary-modern {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1.75rem;
  background: white;
  color: #6b7280;
  font-weight: 600;
  font-size: 0.9375rem;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.btn-secondary-modern:hover:not(:disabled) {
  background: #f9fafb;
  border-color: #d1d5db;
  color: #374151;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.btn-secondary-modern:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-primary-modern {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1.75rem;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: white;
  font-weight: 600;
  font-size: 0.9375rem;
  border: none;
  border-radius: 12px;
  transition: all 0.3s ease;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
}

.btn-primary-modern:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.4);
}

.btn-primary-modern:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-cancel-modern {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1.75rem;
  background: white;
  color: #6b7280;
  font-weight: 600;
  font-size: 0.9375rem;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  transition: all 0.3s ease;
  text-decoration: none;
}

.btn-cancel-modern:hover {
  background: #f9fafb;
  border-color: #d1d5db;
  color: #374151;
  transform: translateY(-2px);
}

.btn-generate-modern {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 2rem;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  font-weight: 600;
  font-size: 0.9375rem;
  border: none;
  border-radius: 12px;
  transition: all 0.3s ease;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.btn-generate-modern:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);
}

.btn-generate-modern:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Success Message */
.success-message {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-top: 2rem;
  padding: 1.5rem;
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  border: 2px solid #6ee7b7;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
}

.success-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #10b981;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.success-content {
  flex: 1;
}

.success-title {
  font-size: 1.125rem;
  font-weight: 700;
  color: #065f46;
  margin-bottom: 0.25rem;
}

.success-text {
  font-size: 0.9375rem;
  color: #047857;
  line-height: 1.5;
}

/* Success Transition */
.success-fade-enter-active {
  animation: slide-up 0.5s ease-out;
}

.success-fade-leave-active {
  animation: fade-in 0.3s ease-out reverse;
}

/* ========================================
   PREVIEW FULLSCREEN - PostDetail Style
   ======================================== */

.preview-section-fullscreen {
  margin: 0 -2.5rem;
  padding: 0;
  background: #ffffff;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  position: relative;
}

.preview-badge-container {
  position: sticky;
  top: 0;
  z-index: 50;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(12px);
  padding: 1rem 2rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.preview-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  font-weight: 600;
  font-size: 0.875rem;
  border-radius: 999px;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.post-preview-article {
  background: white;
}

/* Hero Image Section */
.post-hero-image {
  position: relative;
  height: 500px;
  overflow: hidden;
}

.post-hero-gradient {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.4),
    rgba(0, 0, 0, 0.2),
    transparent
  );
  z-index: 10;
}

.post-hero-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.post-hero-header {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 20;
  padding: 2rem 3rem;
}

.post-hero-content {
  max-width: 56rem;
  margin: 0 auto;
}

.post-hero-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: white;
  margin-bottom: 1rem;
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
  line-height: 1.2;
}

/* Content Wrapper */
.post-content-wrapper {
  max-width: 56rem;
  margin: 0 auto;
  padding: 0 2rem;
}

/* Header without image */
.post-header-no-image {
  margin-bottom: 3rem;
  margin-top: 2rem;
}

.post-theme-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.5rem 1rem;
  border-radius: 999px;
  font-size: 0.875rem;
  font-weight: 500;
  background: #eff6ff;
  color: #1e40af;
  margin-bottom: 1.5rem;
}

.post-theme-dot {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background: #3b82f6;
  margin-right: 0.5rem;
}

.post-title-no-image {
  font-size: 3rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 1.5rem;
  line-height: 1.2;
}

/* Author & Meta */
.post-meta-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid #e5e7eb;
}

.post-author-info {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.post-author-avatar {
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 0 2px white, 0 4px 8px rgba(0, 0, 0, 0.1);
}

.post-author-initial {
  color: white;
  font-weight: 700;
  font-size: 1.125rem;
}

.post-author-name {
  font-weight: 600;
  color: #111827;
  font-size: 1.125rem;
}

.post-meta-details {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.875rem;
  color: #6b7280;
}

.post-meta-separator {
  color: #d1d5db;
}

/* Post Content - Magazine Style (Same as PostDetail) */
.post-content-container {
  margin-bottom: 4rem;
}

.post-content-modern {
  font-family: "Georgia", "Times New Roman", serif;
  font-size: 1.125rem;
  line-height: 1.8;
  color: #1a1a1a;
  letter-spacing: -0.003em;
  overflow-x: hidden;
  max-width: 100%;
}

.post-content-modern :deep(h1),
.post-content-modern :deep(h2),
.post-content-modern :deep(h3) {
  font-family: "Inter", system-ui, -apple-system, sans-serif;
  font-weight: 700;
  letter-spacing: -0.02em;
  margin-top: 2.5rem;
  margin-bottom: 1.25rem;
  color: #111827;
}

.post-content-modern :deep(h1) {
  font-size: 2.5rem;
  line-height: 1.2;
}

.post-content-modern :deep(h2) {
  font-size: 2rem;
  line-height: 1.3;
  border-bottom: 2px solid #e5e7eb;
  padding-bottom: 0.5rem;
}

.post-content-modern :deep(h3) {
  font-size: 1.5rem;
  line-height: 1.4;
}

.post-content-modern :deep(p) {
  margin-bottom: 1.75rem;
  text-align: justify;
  hyphens: auto;
}

.post-content-modern :deep(strong) {
  font-weight: 600;
  color: #111827;
}

.post-content-modern :deep(em) {
  font-style: italic;
  color: #374151;
}

.post-content-modern :deep(ul),
.post-content-modern :deep(ol) {
  margin-bottom: 1.75rem;
  padding-left: 1.75rem;
}

.post-content-modern :deep(li) {
  margin-bottom: 0.75rem;
  line-height: 1.7;
}

.post-content-modern :deep(blockquote) {
  border-left: 4px solid #3b82f6;
  padding-left: 1.5rem;
  margin: 2rem 0;
  font-style: italic;
  color: #4b5563;
  background: #f9fafb;
  padding: 1.5rem;
  border-radius: 0.5rem;
}

/* Table responsive wrapper */
.post-content-modern :deep(.table-responsive-wrapper) {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin: 2rem 0;
  max-width: 100%;
  width: 100%;
}

/* Table styles - professional magazine look */
.post-content-modern :deep(table) {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin: 0;
  font-family: "Inter", system-ui, -apple-system, sans-serif;
  font-size: 0.9rem;
  line-height: 1.6;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06);
  min-width: 600px;
}

.post-content-modern :deep(thead) {
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
}

.post-content-modern :deep(th) {
  padding: 0.875rem 1.25rem;
  font-weight: 600;
  font-size: 0.8125rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #f1f5f9;
  border: none;
  border-bottom: 2px solid #475569;
  text-align: left;
}

.post-content-modern :deep(td) {
  padding: 0.875rem 1.25rem;
  color: #374151;
  border-bottom: 1px solid #e5e7eb;
  vertical-align: top;
  font-family: "Georgia", "Times New Roman", serif;
  font-size: 0.9375rem;
}

@media (max-width: 768px) {
  .post-content-modern :deep(th),
  .post-content-modern :deep(td) {
    padding: 0.625rem 0.75rem;
    font-size: 0.8125rem;
  }
  .post-content-modern :deep(table) {
    font-size: 0.8rem;
  }
}

.post-content-modern :deep(tr:last-child td) {
  border-bottom: none;
}

.post-content-modern :deep(tbody tr) {
  transition: background-color 0.15s ease;
}

.post-content-modern :deep(tbody tr:nth-child(even)) {
  background-color: #f8fafc;
}

.post-content-modern :deep(tbody tr:hover) {
  background-color: #eff6ff;
}

.post-content-modern :deep(td strong) {
  color: #111827;
  font-weight: 600;
}

.post-content-modern :deep(code) {
  background: #f3f4f6;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-family: "Monaco", "Courier New", monospace;
  font-size: 0.9em;
  color: #dc2626;
}

.post-content-modern :deep(pre) {
  background: #1e1e1e !important;
  border-radius: 6px !important;
  border: 1px solid #484f58 !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
  position: relative;
  margin: 2rem 0 !important;
  padding: 0 !important;
  overflow: hidden;
}

.post-content-modern :deep(pre::before) {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 30px;
  background: #141619;
  z-index: 1;
  border-radius: 5px 5px 0 0;
}

.post-content-modern :deep(pre code) {
  padding: 1.5rem 1rem 1rem 1rem !important;
  display: block !important;
  position: relative;
  z-index: 3;
  background: transparent;
  color: #f8f8f2 !important;
}

/* First letter drop cap effect */
.post-content-modern :deep(> p:first-of-type::first-letter) {
  float: left;
  font-size: 4.5rem;
  line-height: 0.85;
  margin: 0.1em 0.15em 0 0;
  font-weight: 700;
  color: #3b82f6;
  font-family: "Georgia", serif;
}

/* Enhanced inline code */
.post-content-modern :deep(code:not(pre code)) {
  background: rgba(110, 118, 129, 0.4) !important;
  color: #f8f8f2 !important;
  padding: 2px 6px !important;
  border-radius: 4px !important;
  font-family: "SF Mono", Monaco, Inconsolata, "Fira Code", monospace !important;
  font-size: 0.85em !important;
  border: 1px solid rgba(110, 118, 129, 0.3) !important;
}

/* Prism.js Syntax Highlighting */
.post-content-modern :deep(.token.comment),
.post-content-modern :deep(.token.prolog),
.post-content-modern :deep(.token.doctype),
.post-content-modern :deep(.token.cdata) {
  color: #6a737d;
  font-style: italic;
}

.post-content-modern :deep(.token.punctuation) {
  color: #f8f8f2;
}

.post-content-modern :deep(.token.property),
.post-content-modern :deep(.token.tag),
.post-content-modern :deep(.token.constant),
.post-content-modern :deep(.token.symbol),
.post-content-modern :deep(.token.deleted) {
  color: #e06c75;
}

.post-content-modern :deep(.token.boolean),
.post-content-modern :deep(.token.number) {
  color: #d19a66;
}

.post-content-modern :deep(.token.selector),
.post-content-modern :deep(.token.attr-name),
.post-content-modern :deep(.token.string),
.post-content-modern :deep(.token.char),
.post-content-modern :deep(.token.builtin),
.post-content-modern :deep(.token.inserted) {
  color: #98c379;
}

.post-content-modern :deep(.token.operator),
.post-content-modern :deep(.token.entity),
.post-content-modern :deep(.token.url),
.post-content-modern :deep(.language-css .token.string),
.post-content-modern :deep(.style .token.string) {
  color: #56b6c2;
}

.post-content-modern :deep(.token.atrule),
.post-content-modern :deep(.token.attr-value),
.post-content-modern :deep(.token.function),
.post-content-modern :deep(.token.class-name) {
  color: #61aeee;
}

.post-content-modern :deep(.token.keyword) {
  color: #c678dd;
}

.post-content-modern :deep(.token.regex),
.post-content-modern :deep(.token.important),
.post-content-modern :deep(.token.variable) {
  color: #d19a66;
}

/* Floating Action Bar */
.preview-action-bar {
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(12px);
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  padding: 1.5rem 2rem;
  z-index: 40;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.05);
}

.preview-actions-content {
  max-width: 56rem;
  margin: 0 auto;
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
}

.btn-preview-secondary {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1.75rem;
  background: white;
  color: #6b7280;
  font-weight: 600;
  font-size: 0.9375rem;
  border-radius: 12px;
  border: 2px solid #e5e7eb;
  transition: all 0.3s ease;
  cursor: pointer;
}

.btn-preview-secondary:hover:not(:disabled) {
  background: #f9fafb;
  border-color: #d1d5db;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.btn-preview-secondary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-preview-primary {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1.75rem;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  font-weight: 600;
  font-size: 0.9375rem;
  border-radius: 12px;
  border: none;
  transition: all 0.3s ease;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.btn-preview-primary:hover:not(:disabled) {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
}

.btn-preview-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Responsive */
@media (max-width: 768px) {
  .preview-section-fullscreen {
    margin: 0 -1rem;
  }

  .post-hero-title {
    font-size: 2rem;
  }

  .post-title-no-image {
    font-size: 2rem;
  }

  .post-content-modern {
    font-size: 1rem;
  }

  .post-content-modern :deep(h1) {
    font-size: 2rem;
  }

  .post-content-modern :deep(h2) {
    font-size: 1.75rem;
  }

  .post-content-modern :deep(h3) {
    font-size: 1.25rem;
  }

  .post-content-modern :deep(> p:first-of-type::first-letter) {
    font-size: 3.5rem;
  }

  .preview-actions-content {
    flex-direction: column;
  }

  .btn-preview-secondary,
  .btn-preview-primary {
    width: 100%;
    justify-content: center;
  }
}

/* ==================== MARKDOWN EDITOR ==================== */

.editor-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2px;
  padding: 0.5rem;
  background: #f9fafb;
  border: 2px solid #e5e7eb;
  border-bottom: none;
  border-radius: 16px 16px 0 0;
}

.toolbar-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: none;
  background: transparent;
  color: #4b5563;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.875rem;
  transition: all 0.2s ease;
}

.toolbar-btn:hover {
  background: #e5e7eb;
  color: #1f2937;
}

.toolbar-btn-active {
  background: #dbeafe;
  color: #1d4ed8;
}

.toolbar-separator {
  width: 1px;
  height: 24px;
  background: #d1d5db;
  margin: 0 4px;
}

.editor-container {
  border: 2px solid #e5e7eb;
  border-top: none;
  border-radius: 0 0 16px 16px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.editor-split {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.editor-pane {
  min-height: 400px;
}

.editor-textarea {
  width: 100%;
  min-height: 400px;
  padding: 1.25rem;
  font-family: "Monaco", "Courier New", monospace;
  font-size: 0.875rem;
  line-height: 1.7;
  color: #1f2937;
  background: #ffffff;
  border: none;
  outline: none;
  resize: vertical;
  tab-size: 2;
}

.editor-textarea:focus {
  box-shadow: inset 0 0 0 2px rgba(99, 102, 241, 0.2);
}

.editor-textarea::placeholder {
  color: #9ca3af;
}

.editor-textarea:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.preview-pane {
  border-left: 2px solid #e5e7eb;
  background: #ffffff;
  overflow-y: auto;
  max-height: 500px;
}

.preview-pane-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1.25rem;
  background: #f0f9ff;
  color: #1d4ed8;
  font-size: 0.8125rem;
  font-weight: 600;
  border-bottom: 1px solid #e5e7eb;
}

.preview-pane-content {
  padding: 1.25rem;
  font-size: 1rem;
  line-height: 1.7;
}

/* Editor responsive */
@media (max-width: 768px) {
  .editor-split {
    grid-template-columns: 1fr;
  }

  .preview-pane {
    border-left: none;
    border-top: 2px solid #e5e7eb;
    max-height: 300px;
  }

  .mode-tabs {
    flex-direction: column;
  }

  .mode-tab {
    justify-content: center;
  }
}

/* ==================== IMAGE UPLOAD ==================== */

.image-mode-tabs {
  display: flex;
  gap: 0.25rem;
  background: #f3f4f6;
  padding: 0.25rem;
  border-radius: 10px;
  width: fit-content;
}

.image-mode-tab {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.5rem 1rem;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #6b7280;
  background: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.image-mode-tab:hover {
  color: #374151;
}

.image-mode-tab-active {
  background: white;
  color: #1d4ed8;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.upload-dropzone {
  border: 2px dashed #d1d5db;
  border-radius: 16px;
  padding: 2rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #fafafa;
}

.upload-dropzone:hover {
  border-color: #93c5fd;
  background: #f0f9ff;
}

.upload-dropzone-active {
  border-color: #3b82f6;
  background: #eff6ff;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
}

.upload-placeholder {
  pointer-events: none;
}

.image-remove-btn {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s ease;
  opacity: 0;
}

.image-preview:hover .image-remove-btn {
  opacity: 1;
}

.image-remove-btn:hover {
  background: rgba(239, 68, 68, 0.9);
  transform: scale(1.1);
}
</style>
